<template>
	<div class="hello">
		<!-- 头 -->
		<tyheader pageind="0" />
		<!-- 轮播 -->
		<div class="swiperbox" :class="{mt_60:isshow}">
			<swiper class="bannerind" :options="swiperOption" ref="mySwiper">
				<swiper-slide v-for="(item, index) in bannerlist" :key="index">
					<div class="listing-img">
						<img :src="item.image"></img>
					</div>
				</swiper-slide>
			 <div class="swiper-button-prev topbanner1" :class="isshow ? 'topbannerpc' : 'topbannerph'"
					slot="button-prev"></div>
				<div class="swiper-button-next topbanner2" :class="isshow ? 'topbannerpc' : 'topbannerph'"
					slot="button-next"></div>
			</swiper>
			<img class="ban-sp" src="../assets/images/ban-sp.png">
			<div class="icon-scroll animate breath arrow animated" :class="{disnone:!isshow}" data-animate="arrow"
				style="visibility: visible;"></div>
		</div>
		<!-- 产品 -->
		<div class="probg">
			<div class="w1400">
				<swiper class="brand-bar" :options="swiperOption1" ref="mySwiper1">
					<swiper-slide v-for="(item, index) in prolist" :key="index">
						<span class="langdon">{{item.name}}</span>
						<i></i>
					</swiper-slide>
					<!-- <swiper-slide>
						<span class="langdon">双沟珍宝坊</span>
						<i></i>
					</swiper-slide>
					<swiper-slide>
						<span class="langdon">双沟系列</span>
						<i></i>
					</swiper-slide>
					<swiper-slide>
						<span class="langdon">其他系列</span>
						<i></i>
					</swiper-slide> -->
				</swiper>
				<swiper class=" brand-wrapper" :options="swiperOption2" ref="mySwiper2">
					<swiper-slide v-for="(item, index) in proarry" :key="index">
						<div class="product-list clearfix" style="max-height: 600px;overflow-y: scroll;">
							<div v-for="(items, ind) in item" :key="ind" class="item"
								:class="isshow ? 'itempc' : 'itemph'" style="cursor: pointer;">
								<div class="pic pic1">
									<router-link class="nav-link" style="position: relative;"
										:to="{path:'/prodetail',query: {type: items.code}}">
										<img :src="items.showImg">
										<img src="../assets/images/pro-bg.png" class="probgtry">
									</router-link>
								</div>
								<div class="detail">
									<router-link class="nav-link" :to="{path:'/prodetail',query: {type: items.code}}">
										<div class="title">{{items.name}}</div>
										<div class="guige">
											<span>酒精度<br>{{items.Vol}}</span>
											<span>香型<br>{{items.scent}}</span>
											<span>等级<br>{{items.levels}}</span>
											<span>{{items.netcontent.length > 1 ? items.netcontent[0] : '净含量'}}<br>{{items.netcontent.length > 1 ? items.netcontent[1] : items.netcontent[0]}}</span>
										</div>
										<div class="intro">{{items.intro}}</div>
									</router-link>
								</div>
							</div>
							<!-- <div class="item" style="cursor: pointer;">
								<div class="pic">
									<a href="toupaijiu.html"><img src="../assets/images/pro10.png"></a>
								</div>
								<div class="detail">
									<a href="toupaijiu.html">
										<div class="title">苏酒头排酒</div>
									</a>
									<div class="guige">
										<span>酒精度<br>52/40.8度</span>
										<span>香型<br>绵柔型</span>
										<span>等级<br>优级</span>
										<span>净含量<br>500ML</span>
									</div>
									<div class="intro">头排酒与明前茶具有一样的特质：珍贵、稀缺、品质极致。每年春分时节入窖、白露时节开窖，经历12个节气，180天的超长时间发酵，生产成本虽高，但品质最好。</div>
								</div>
							</div>
							<div class="item" style="cursor: pointer;">
								<div class="pic">
									<a href="toupaijiu.html"><img src="../assets/images/pro10.png"></a>
								</div>
								<div class="detail">
									<a href="toupaijiu.html">
										<div class="title">苏酒头排酒</div>
									</a>
									<div class="guige">
										<span>酒精度<br>52/40.8度</span>
										<span>香型<br>绵柔型</span>
										<span>等级<br>优级</span>
										<span>净含量<br>500ML</span>
									</div>
									<div class="intro">头排酒与明前茶具有一样的特质：珍贵、稀缺、品质极致。每年春分时节入窖、白露时节开窖，经历12个节气，180天的超长时间发酵，生产成本虽高，但品质最好。</div>
								</div>
							</div> -->

						</div>
					</swiper-slide>

					<div class="btns">
						<span class="brand-prev  swiper-button-disabled" tabindex="0" role="button"
							aria-label="Previous slide" aria-disabled="true"></span>
						<span class="brand-next " tabindex="0" role="button" aria-label="Next slide"
							aria-disabled="false"></span>
					</div>
				</swiper>
			</div>
		</div>
		<!-- 中间图 -->
		<div v-if="isshow" class="midswiper">
			<div class="">
				<swiper class="midswiper1" :options="swiperOption3" ref="mySwiper3">
					<swiper-slide>
						<router-link to="/about?type=1631179008439&ind=4">
							<div class="swipermod" style="height: 100%;">
								<img class="imgsty" src="../assets/images/pic1.jpg">
								<div class="swipermodword">
									<div class="title-txt">双沟荣誉</div>
									<div class="txtword" style="padding-top:0px;">
										1910年，双沟大曲在清政府举办的南洋劝业会上获得金奖<br>1955年，双沟大曲在全国第一届酿酒工业大会被评为甲等佳酒<br>1984年,双沟大曲获国家金质奖<br>2012年，绵柔苏酒荣获“2012年度中国白酒国家评委感官质量奖”<br>2017年，双沟酒文化旅游区被评为国家AAAA级旅游景区<br>2018年，绵柔苏酒成功获评“中国白酒酒体设计奖”<br>2018年，柔和双沟（铂金版）荣获“中国白酒感官质量奖”
									</div>
									<div class="showmore">查看更多</div>
									</div>
						</div>
						</router-link>
					</swiper-slide>
					<swiper-slide>
						<router-link to="/about?type=1631178998087&ind=2">
							<div class="swipermod" style="height: 100%;">
								<img class="imgsty" src="../assets/images/pic2.jpg">
								<div class="swipermodword">
									<div class="title-txt">历史文化</div>
									<div class="txtword">双沟地区是人类文明的发祥地之一，<br>早在1800万年前，双沟一带乃至泗洪地区就生活猿人。
										<br>双沟地区酿酒历史起于殷商，繁于隋唐，盛于宋明。<br>1910年，双沟大曲参加南洋劝业会，荣获金牌奖，<br>为此，国父孙中山欣然题写了“双沟醴泉”以示嘉许。<br>
										抗战时期，陈毅元帅为双沟酒业留下“不愧天下第一流”的赞誉。<br>建国后，双沟大曲更是誉满天下，跻身国家名酒行列。
									</div>
									<div class="showmore">查看更多</div>
								</div>
							</div>
						</router-link>
					</swiper-slide>
					<swiper-slide>
						<router-link to="/hxys?type=1631179556407&ind=3">
							<div class="swipermod" style="height: 100%;">
								<img class="imgsty" src="../assets/images/pic3.jpg">
								<div class="swipermodword">
									<div class="title-txt">质量安全</div>
									<div class="txtword">无论是严格按照绿色食品标准采购的酿酒原粮，<br>还是决定酒质口感的优质水源，
										<br>双沟酒业都进行了严格筛选，精中选精，优中选优，<br>&nbsp;从源头上确保产品质量安全。<br>每一个环节都有着严格的技术标准和质量规范。<br>
										正是对细节的从严把控，成就了双沟产品的卓越品质。
									</div>
									<div class="showmore">查看更多</div>
									</div>
						</div>
						</router-link>
					</swiper-slide>
					<swiper-slide>
						<router-link to="/hxys?type=1631179549898&ind=2">
							<div class="swipermod" style="height: 100%;">
								<img class="imgsty" src="../assets/images/pic4.jpg">
								<div class="swipermodword">
									<div class="title-txt">工匠精神</div>
									<div class="txtword">白酒是传统发酵产业，<br>之所以有“传统”二字，根本在于传承。<br>酿酒技艺通过口传心授的方式代代相传，
										<br>让艺人的“德”和融入酒中的工匠文化得以传承。<br>这是中国白酒最核心的东西，<br>构成了区别于其他酒种和其他蒸馏酒的本质特征。<br>
									</div>
									<div class="showmore">查看更多</div>
								</div>
							</div>
						</router-link>
					</swiper-slide>
					<swiper-slide>
						<router-link to="/zhwl?type=&index=4">
							<div class="swipermod" style="height: 100%;">
								<img class="imgsty" src="../assets/images/pic5.jpg">
								<!-- <div class="imgsty" style="background-image: url(http://sgjy.seo518.cn/static/image/pic5.jpg);"></div> -->
								<div class="swipermodword">
									<div class="title-txt">智慧文旅</div>
									<div class="txtword">包括岁月双沟文化体验区和科技双沟旅游休闲区，<br>历史浑厚的醉猿洲、雅苑、双沟老街、淮上客栈，
										<br>现代化的包装物流中心，<br>规模宏大的酿酒生产厂房等景点，<br>双沟酒素有“名驰冀北三千里，味占江淮第一家”的美誉，<br>
										到双沟，品生态苏酒、寻世界自然酒起源的地方。
									</div>
									<div class="showmore">查看更多</div>
									</div>
						</div>
						</router-link>
					</swiper-slide>
					<div class="swiper-button-prev midbanner1" :class="isshow ? 'topbannerpc' : 'topbannerph'"
						slot="button-prev"></div>
					<div class="swiper-button-next midbanner2" :class="isshow ? 'topbannerpc' : 'topbannerph'"
						slot="button-next"></div>
				</swiper>
			</div>
		</div>
		<div v-else class="midswiper">
			<div class="">
				<swiper class="midswiper1" :options="swiperOption7" ref="mySwiper7">
					<swiper-slide>
						<router-link to="/about?type=1631179008439&ind=4">
							<div class="swipermod" style="height: 100%;">
								<img class="imgsty" src="../assets/images/pic1.jpg">
								<!-- <div class="imgsty" style="background-image: url(http://sgjy.seo518.cn/static/image/pic1.jpg);"></div> -->
								<div class="swipermodword">
									<div class="title-txt">双沟荣誉</div>
									<div class="txtword" style="padding-top:0px;width: 120px;overflow: hidden;">
										1910年，双沟大曲在清政府举办的南洋劝业会上获得金奖<br>1955年，双沟大曲在全国第一届酿酒工业大会被评为甲等佳酒<br>1984年,双沟大曲获国家金质奖<br>2012年，绵柔苏酒荣获“2012年度中国白酒国家评委感官质量奖”<br>2017年，双沟酒文化旅游区被评为国家AAAA级旅游景区<br>
										2018年，绵柔苏酒成功获评“中国白酒酒体设计奖”<br>2018年，柔和双沟（铂金版）荣获“中国白酒感官质量奖”
									</div>
									<div class="showmore" style="top:12rem;">查看更多</div>
									</div>
						</div>
						</router-link>
					</swiper-slide>
					<swiper-slide>
						<router-link to="/about?type=1631178998087&ind=2">
							<div class="swipermod" style="height: 100%;">
								<img class="imgsty" src="../assets/images/pic2.jpg">
								<!-- <div class="imgsty" style="background-image: url(http://sgjy.seo518.cn/static/image/pic2.jpg);"></div> -->
								<div class="swipermodword">
									<div class="title-txt">历史文化</div>
									<div class="txtword" style="padding-top:0px;width: 120px;overflow: hidden;">
										双沟地区是人类文明的发祥地之一，<br>早在1800万年前，双沟一带乃至泗洪地区就生活猿人。
										<br>双沟地区酿酒历史起于殷商，繁于隋唐，盛于宋明。<br>1910年，双沟大曲参加南洋劝业会，荣获金牌奖，<br>为此，国父孙中山欣然题写了“双沟醴泉”以示嘉许。<br>
										抗战时期，陈毅元帅为双沟酒业留下“不愧天下第一流”的赞誉。<br>建国后，双沟大曲更是誉满天下，跻身国家名酒行列。
									</div>
									<div class="showmore" style="top:12rem;">查看更多</div>
								</div>
							</div>
						</router-link>
					</swiper-slide>
					<swiper-slide>
						<router-link to="/hxys?type=1631179556407&ind=3"></a>
							<div class="swipermod" style="height: 100%;">
								<img class="imgsty" src="../assets/images/pic3.jpg">
								<!-- <div class="imgsty" style="background-image: url(http://sgjy.seo518.cn/static/image/pic3.jpg);"></div> -->
								<div class="swipermodword">
									<div class="title-txt">质量安全</div>
									<div class="txtword" style="padding-top:0px;width: 120px;overflow: hidden;">
										无论是严格按照绿色食品标准采购的酿酒原粮，<br>还是决定酒质口感的优质水源，
										<br>双沟酒业都进行了严格筛选，精中选精，优中选优，<br>&nbsp;从源头上确保产品质量安全。<br>每一个环节都有着严格的技术标准和质量规范。<br>
										正是对细节的从严把控，成就了双沟产品的卓越品质。
									</div>
									<div class="showmore" style="top:12rem;">查看更多</div>
									</div>
						</div>
						</router-link>
					</swiper-slide>
					<swiper-slide>
						<router-link to="/hxys?type=1631179549898&ind=2">
							<div class="swipermod" style="height: 100%;">
								<img class="imgsty" src="../assets/images/pic4.jpg">
								<!-- <div class="imgsty" style="background-image: url(http://sgjy.seo518.cn/static/image/pic4.jpg);"></div> -->
								<div class="swipermodword">
									<div class="title-txt">工匠精神</div>
									<div class="txtword" style="padding-top:0px;width: 120px;overflow: hidden;">
										白酒是传统发酵产业，<br>之所以有“传统”二字，根本在于传承。<br>酿酒技艺通过口传心授的方式代代相传，
										<br>让艺人的“德”和融入酒中的工匠文化得以传承。<br>这是中国白酒最核心的东西，<br>构成了区别于其他酒种和其他蒸馏酒的本质特征。<br>
									</div>
									<div class="showmore" style="top:12rem;">查看更多</div>
								</div>
							</div>
						</router-link>
					</swiper-slide>
					<swiper-slide>
						<router-link to="/zhwl?type=&index=4">
							<div class="swipermod" style="height: 100%;">
								<img class="imgsty" src="../assets/images/pic5.jpg">
								<!-- <div class="imgsty" style="background-image: url(http://sgjy.seo518.cn/static/image/pic5.jpg);"></div> -->
								<div class="swipermodword">
									<div class="title-txt">智慧文旅</div>
									<div class="txtword" style="padding-top:0px;width: 120px;overflow: hidden;">
										包括岁月双沟文化体验区和科技双沟旅游休闲区，<br>历史浑厚的醉猿洲、雅苑、双沟老街、淮上客栈，
										<br>现代化的包装物流中心，<br>规模宏大的酿酒生产厂房等景点，<br>双沟酒素有“名驰冀北三千里，味占江淮第一家”的美誉，<br>
										到双沟，品生态苏酒、寻世界自然酒起源的地方。
									</div>
									<div class="showmore" style="top:12rem;">查看更多</div>
									</div>
						</div>
						</router-link>
					</swiper-slide>
				</swiper>
			</div>
		</div>
		<!-- 新闻 -->
		<div class="newsbg">
			<div class="w1400" :class="isshow?'newspc':'newsph'">
				<div class="title_box center">
					<div class="title">
						<h3>新闻<span>资讯</span></h3>
					</div>
				</div>
				<div class="nemu" :class="isshow?'':'sjmodtab'">
					<a v-for="(item, index) in newsmenu" :key="index" @mouseenter="changeTab(index)"
						:class="{active:newsind==index}">
						<div class="bp-inner" :class="isshow?'':'sjmodtabwidth'">{{item.title}}</div>
					</a>
					<!-- <a href="#" @mouseenter="changeTab(1)" :class="{active:newsind==1}"><div class="bp-inner">媒体报道</div></a>
					<a href="#" @mouseenter="changeTab(2)" :class="{active:newsind==2}"><div class="bp-inner">双沟酒讯</div></a>
					<a href="#" @mouseenter="changeTab(3)" :class="{active:newsind==3}"><div class="bp-inner">集团公告</div></a>
					<a href="#" @mouseenter="changeTab(4)" :class="{active:newsind==4}"><div class="bp-inner">招标信息</div></a> -->
					<div class="t_line">
						<div class="bd"></div>
					</div>
				</div>
				<div class="news-container news-wrapper" :class="{disnone:newsind!=0}">
					<div v-for="(item, index) in newslist0" v-if="index<4" :key="index" class="item">
						<router-link class="nav-link" :to="{path:'/newsdetail',query: {code: item.code}}">
							<div class="wrap">
								<div class="insteada">
									<div class="pic">
										<img :src="item.showImage" />
										<span>{{item.time}}</span>
									</div>
									<h2 class="title" :title="item.title">{{item.title}}</h2>
									<p class="intro">{{item.intro}}</p>
									<div class="btn">
										<div class="tryani"><span>查看详细</span><i></i></div>
									</div>
								</div>
							</div>
						</router-link>
					</div>

				</div>

				<div class="news-container news-wrapper" :class="{disnone:newsind!=1}">
					<div v-for="(item, index) in newslist1" v-if="index<4" :key="index" class="item">
						<router-link class="nav-link" :to="{path:'/newsdetail',query: {code: item.code}}">
							<div class="wrap">
								<div class="insteada">
									<div class="pic">
										<img :src="item.showImage" />
										<span>{{item.time}}</span>
									</div>
									<h2 class="title" :title="item.title">{{item.title}}</h2>
									<p class="intro">{{item.intro}}</p>
									<div class="btn">
										<div class="tryani"><span>查看详细</span><i></i></div>
									</div>
								</div>
							</div>
						</router-link>
					</div>
				</div>
				<div class="news-container news-wrapper" :class="{disnone:newsind!=2}">
					<div v-for="(item, index) in newslist2" v-if="index<4" :key="index" class="item">
						<router-link class="nav-link" :to="{path:'/newsdetail',query: {code: item.code}}">
							<div class="wrap">
								<div class="insteada">
									<div class="pic">
										<img :src="item.showImage" />
										<span>{{item.time}}</span>
									</div>
									<h2 class="title" :title="item.title">{{item.title}}</h2>
									<p class="intro">{{item.intro}}</p>
									<div class="btn">
										<div class="tryani"><span>查看详细</span><i></i></div>
									</div>
								</div>
							</div>
						</router-link>
					</div>
				</div>
				<div class="news-container news-wrapper" :class="{disnone:newsind!=3}">
					<div v-for="(item, index) in newslist3" v-if="index<4" :key="index" class="item">
						<router-link class="nav-link" :to="{path:'/newsdetail',query: {code: item.code}}">
							<div class="wrap">
								<div class="insteada">
									<div class="pic">
										<img :src="item.showImage" />
										<span>{{item.time}}</span>
									</div>
									<h2 class="title" :title="item.title">{{item.title}}</h2>
									<p class="intro">{{item.intro}}</p>
									<div class="btn">
										<div class="tryani"><span>查看详细</span><i></i></div>
									</div>
								</div>
							</div>
						</router-link>
					</div>
				</div>
				<div class="news-container news-wrapper" :class="{disnone:newsind!=4}">
					<div v-for="(item, index) in newslist4" v-if="index<4" :key="index" class="item">
						<router-link class="nav-link" :to="{path:'/newsdetail',query: {code: item.code}}">
							<div class="wrap">
								<div class="insteada">
									<div class="pic">
										<img :src="item.showImage" />
										<span>{{item.time}}</span>
									</div>
									<h2 class="title" :title="item.title">{{item.title}}</h2>
									<p class="intro">{{item.intro}}</p>
									<div class="btn">
										<div class="tryani"><span>查看详细</span><i></i></div>
									</div>
								</div>
							</div>
						</router-link>
					</div>
				</div>

			</div>

			<tyfooter pageind="0"></tyfooter>
		</div>

		<!-- donghua -->
<!--		<div :class="isshow?'disblock':'disnone'">-->
<!--			<div v-if="anionoff == true" class="load2bg1"></div>-->
<!--			<div v-if="anionoff == true" class="load2bg2"></div>-->
<!--			<div v-if="anionoff == true" class="load2bg">-->
<!--				<div class="logozfx"></div>-->
<!--				<div class="wrapper3after"></div>-->
<!--				<button class="kch3" style="z-index: 99999999;" @click="closeani">跳过动画</button>-->
<!--				<div class="ban-video">-->
<!--					<video id="video" src="http://cdn.seo518.cn/sgsp211009.mp4" autoplay="autoplay" muted=""></video>-->
<!--				</div>-->
<!--			</div>-->
<!--		</div>-->


	</div>
</template>

<script>
	let that = null;
	let proarry = []
	// 引入插件
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper";
	import "swiper/dist/css/swiper.css";

	import tyheader from './header.vue'
	import tyfooter from './footer.vue'
	export default {
		name: 'index',
		components: {
			swiper,
			swiperSlide,
			tyheader,
			tyfooter
		},
		metaInfo() {
			return {
				title: this.seot,
				meta: [ // set meta
					{
						name: 'keyWords',
						content: this.seok
					},
					{
						name: 'description',
						content: this.seod
					}
				]
			}
		},
		data() {
			return {
				seot: this.COMMON.seotit,
				seod: this.COMMON.seodec,
				seok: this.COMMON.seokey,
				isshow: this.COMMON.isshow(),
				imgurl: this.COMMON.imgurl,
				swiperOption: {
					loop: true,
					pagination: {
						el: ".swiper-pagination",
						clickable: true //允许分页点击跳转
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
				},
				swiperOption1: {
					slidesPerView: 'auto',
					centeredSlides: true,
					slideToClickedSlide: true,
					notNextTick: true,
					on: {
						slideChangeTransitionStart() {
							that.swiper2.slideTo(that.swiper1.activeIndex)
						},
						slideChange() {
							that.swipernum = that.swiper1.activeIndex
						}
					}
				},
				swiperOption2: {
					effect: 'fade',
					notNextTick: true,
					navigation: {
						nextEl: '.brand-next',
						prevEl: '.brand-prev',
					},
					on: {
						slideChangeTransitionStart() {
							that.swiper1.slideTo(that.swiper2.activeIndex)
						},
						slideChange() {
							that.swipernum = that.swiper2.activeIndex
						}
					}
				},
				swipernum: '0',
				swiperOption3: {
					loop: true,
					effect: 'coverflow',
					grabCursor: true,
					coverflowEffect: {
						rotate: 0,
						stretch: 10,
						depth: 100,
						modifier: 2,
						slideShadows: true,
					},
					navigation: {
						nextEl: '.midbanner2',
						prevEl: '.midbanner1',
					},
					slidesPerView: 1.4,
					centeredSlides: true,
					spaceBetween: -50,
				},
				swiperOption7: {
					loop: true,
					effect: 'coverflow',
					grabCursor: true,
					coverflowEffect: {
						rotate: 0,
						stretch: 10,
						depth: 100,
						modifier: 2,
						slideShadows: true,
					},
					// loopedSlides: 5,
					slidesPerView: 1.2,
					centeredSlides: true,
					spaceBetween: -50,
				},
				midswipernum: 0,
				// swiperOption4:{
				// 	loop: true,
				// 	loopedSlides: 5,
				// 	spaceBetween: 0,
				// 	slidesPerView: 5,
				// 	centeredSlides: true,
				// 	slideToClickedSlide: true,
				// 	watchSlidesVisibility:true,
				// },
				swipernum1: '0',
				bannerlist: [],
				prolist: [],
				proarry: [],
				newsmenu: [],
				newslist0: [],
				newslist1: [],
				newslist2: [],
				newslist3: [],
				newslist4: [],
				newsind: 0,
				anionoff: this.COMMON.anionoff,
				videotime: ''
			}
		},
		created() {
			that = this;
		},
		computed: {
			swiper() {
				return this.$refs.mySwiper.swiper;
			},
			swiper1() {
				return this.$refs.mySwiper1.swiper;
			},
			swiper2() {
				return this.$refs.mySwiper2.swiper;
			},
			swiper3() {
				return this.$refs.mySwiper3.swiper;
			},
			// swiper4() {
			//   return this.$refs.mySwiper4.swiper;
			// }
		},
		mounted() {
			let that = this
			window.onresize = (e) => {
				that.isshow = that.COMMON.isshow()
			}
			that.$axios.post('/w/pageseo?address=' + '/').then(function(response) {
				if (JSON.stringify(response.data) != "{}") {
					that.seot = response.data.seoTitle
					that.seok = response.data.seoKey
					that.seod = response.data.seoDes
				}
			}).catch(function(error) {
				console.log(error);
			});
			// this.$nextTick(() => {
			// 	const swiperTop = this.$refs.mySwiper3.swiper
			// 	const swiperThumbs = this.$refs.mySwiper4.swiper
			// 	swiperTop.controller.control = swiperThumbs
			// 	swiperThumbs.controller.control = swiperTop
			// })
			// 轮播
			this.getbanner()
			// 产品分类
			this.getprocatelist()
			// 新闻
			this.getmenulist()
			let timedown = setTimeout(function() {
				that.closeani()
			}, 7000)

		},
		methods: {
			timeupdate(e) {
				// console.log(e.duration)
			},
			closeani() {
				this.anionoff = false
				this.COMMON.anionoff = false
			},
			getbanner() {
				let that = this
				this.$axios.post('/w/banner').then(function(response) {
						response.data.forEach((val, ind) => {
							val.image = that.imgurl + val.image
						})
						that.bannerlist = response.data
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			getprocatelist() {
				let that = this
				this.$axios.post('/w/p/category').then(function(response) {
						that.prolist = response.data
						let proarry = [];
						response.data.forEach((val, ind) => {
							val.productList.forEach((value, index) => {
								value.showImg = that.imgurl + value.showImg
								value.netcontent = value.netcontent.split('+')
							})
							proarry.push(val.productList)
						})
						that.proarry = proarry

					})
					.catch(function(error) {
						console.log(error);
					});
			},
			getnewslist(num, ind) {
				let that = this
				this.$axios.post('/w/art?code=&&amount=&&page=&&menuCode=' + num).then(function(response) {
						response.data.list.forEach((val, ind) => {
							val.showImage = that.imgurl + val.showImage
							val.time = val.time.split(' ')[0]
						})
						if (ind == 0) {
							that.newslist0 = response.data.list
						}
						if (ind == 1) {
							that.newslist1 = response.data.list
						}
						if (ind == 2) {
							that.newslist2 = response.data.list
						}
						if (ind == 3) {
							that.newslist3 = response.data.list
						}
						if (ind == 4) {
							that.newslist4 = response.data.list
						}

					})
					.catch(function(error) {
						console.log(error);
					});
			},
			getmenulist() {
				let that = this
				this.$axios.post('/w/menu?code=1631172414011').then(function(response) {
						let newmenu = []
						response.data.forEach((val, ind) => {
							if (ind < 5) {
								newmenu.push(val)
								that.getnewslist(val.code, ind)
							}
						})
						that.newsmenu = newmenu

					})
					.catch(function(error) {
						console.log(error);
					});
			},
			changeTab(num) {
				this.newsind = num
			},
		},
		watch: {

		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.disblock {
		display: block;
	}

	.disnone {
		display: none;
	}

	.swiperbox {
		position: relative;
		width: 100%;
		height: auto;
		overflow: hidden;
	}

	.bannerind {
		position: relative;
		width: 100%;
		height: auto !important;
	}

	.bannerind .swiper-slide {
		width: 100%;
	}

	.listing-img {
		height: auto !important;
		width: 100%;
		background-attachment: initial;
		background-position: center;
		background-size: cover;
	}

	.listing-img img {
		width: 100%;
	}

	.topbanner1,
	.topbanner2 {
		width: 60px;
		height: 60px;
		position: absolute;
		top: calc(50% - 10px);
	}

	.topbanner1 {
		background-image: url(../assets/images/left-arrow.png);
		background-size: 100% 100%;
	}

	.topbanner2 {
		background-image: url(../assets/images/right-arrow.png);
		background-size: 100% 100%;
	}

	.midbanner1,
	.midbanner2 {
		width: 60px;
		height: 60px;
		position: absolute;
		top: calc(50% - 10px);
	}

	.midbanner1 {
		background-image: url(../assets/images/midarrl.png);
		background-size: 100% 100%;
		left: 5rem;
	}

	.midbanner2 {
		background-image: url(../assets/images/midarrr.png);
		background-size: 100% 100%;
		right: 5rem;
	}

	.ban-sp {
		position: absolute;
		bottom: 0;
		z-index: 2;
		width: 100%;
		left: 0px;
	}

	.icon-scroll {
		width: 44px;
		height: 66px;
		position: absolute;
		bottom: 30px;
		left: 50%;
		z-index: 10;
		margin-left: -22px;
		background: url(../assets/images/icon-scroll.png) no-repeat 50%;
		display: block;
		cursor: pointer;
	}

	@keyframes breath {
		0% {
			opacity: 1
		}

		to {
			opacity: 0.6
		}
	}

	.breath {
		animation-name: breath;
		animation-iteration-count: infinite;
		animation-timing-function: linear;
		animation-direction: alternate;
	}

	@keyframes arrow {
		0% {
			opacity: 1;
			transform: translate3d(0, 0, 0)
		}

		to {
			opacity: 0.3;
			transform: translate3d(0, -10px, 0)
		}
	}

	.arrow {
		animation-name: arrow;
		animation-iteration-count: infinite;
		animation-timing-function: linear;
	}

	.animated {
		animation-duration: 1s;
		animation-fill-mode: both;
	}

	/* 产品 */
	.probg {
		/* padding-bottom: 100px; */
		padding-bottom: 230px;
		padding-top: 80px;
		background: url(../assets/images/shan.png) 0 bottom repeat-x #dee8e7;
		-webkit-animation: animate-cloud 40s linear infinite;
		-moz-animation: animate-cloud 40s linear infinite;
		-ms-animation: animate-cloud 40s linear infinite;
		-o-animation: animate-cloud 40s linear infinite;
		animation: animate-cloud 40s linear infinite;
		overflow: hidden;
		background-size: cover;
	}

	.swiper-container {
		overflow: unset !important;
	}

	.brand-bar {
		background: url(../assets/images/icon-line.png) repeat-x center center;
		margin-bottom: 15px;
	}

	.brand-bar .swiper-slide {
		width: 80px;
		height: 18px;
		position: relative;
		margin: 40px 0;
	}

	.brand-bar .swiper-slide span {
		position: absolute;
		top: 24px;
		left: 0;
		display: block;
		width: 100%;
		font-size: 20px;
		color: #3c3c3c;
		line-height: 24px;
		text-align: center;
		cursor: pointer;
		-webkit-transition: font 0.3s ease;
		-o-transition: font 0.3s ease;
		transition: font 0.3s ease;
	}

	.brand-bar .swiper-slide i {
		display: block;
		position: absolute;
		bottom: -2px;
		left: 50%;
		margin-left: -3px;
		width: 8px;
		height: 8px;
		border-radius: 100%;
		overflow: hidden;
		background-color: #119e7f;
		opacity: 0;
	}

	.brand-bar .swiper-slide-active span {
		top: auto;
		bottom: 22px;
		font-size: 30px;
		color: #119e7f;
		line-height: 32px;
	}

	.brand-bar .swiper-slide-active span:before {
		content: '';
		display: inline-block;
		width: 22px;
		height: 44px;
		vertical-align: top;
		background: url(../assets/images/png7.png) no-repeat;
		background-position: left;
		margin-right: 18px;
		position: absolute;
		left: 0;
		top: 10px;
	}

	.brand-bar .swiper-slide-active span:after {
		content: '';
		display: inline-block;
		width: 22px;
		height: 44px;
		vertical-align: top;
		background: url(../assets/images/png7.png) no-repeat;
		background-position: right;
		margin-left: 18px;
		right: 0;
		position: absolute;
		top: 10px;
	}

	.brand-bar .swiper-slide-active i {
		opacity: 1;
	}

	.brand-wrapper .swiper-wrapper {
		height: auto;
	}

	.brand-wrapper .swiper-slide {
		height: auto;
		background: url(../assets/images/png14.png) repeat;
		background: #fff;
		background-size: 60%;
	}

	.product-list {
		position: relative;
		z-index: 2;
		text-align: left;
	}

	.product-list .pic {
		background: url(../assets/images/pro-bg.png) no-repeat center;
		background-size: cover;
	}

	.product-list .pic img {
		border-style: none;
		max-width: 100%;
		vertical-align: top;
		width: auto !important;
		height: auto !important;
	}

	.brand-wrapper .detail {
		padding: 15px;
		padding-left: 30px
	}

	.brand-wrapper .year {
		color: #119e7f;
	}

	.brand-wrapper .year span {
		font-size: 30px;
		line-height: 0.8em;
	}

	.brand-wrapper .year em {
		font-size: 12px;
		font-style: normal;
		vertical-align: top;
		margin-left: 0.2em;
	}

	.brand-wrapper .line {
		display: block;
		width: 1px;
		height: 30px;
		background-color: #119e7f;
		margin: 5px 0 5px 22px;
	}

	.brand-wrapper .title {
		font-size: 18px;
		color: #323232;
		line-height: 1.4em;
		margin-bottom: 5px;
		font-weight: bold;
	}

	.brand-wrapper .intro {
		font-size: 14px;
		color: #8a8a8a;
		line-height: 1.5em;
	}

	.product-list .item {
		float: left;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-moz-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		width: calc(100% - 30px);
		display: -webkit-box;
		display: -webkit-flex;
		display: -moz-box;
		display: -ms-flexbox;
		display: flex;
		padding: 20px 15px;
	}

	.product-list .btn {
		width: 90px;
		height: 35px;
		line-height: 33px;
	}

	.product-list .btn i {
		margin-top: 12px;
	}

	.product-list .detail {
		-webkit-box-flex: 1.5;
		-webkit-flex: 1.5;
		-moz-box-flex: 1.5;
		-ms-flex: 1.5;
		flex: 1.5;
		padding: 15px;
		padding-left: 30px;
	}

	.product-list .title {
		margin-bottom: 20px;
		font-size: 22px;
		font-weight: bold;
		font-family: 'syst';
	}

	.product-list .guige {
		display: -webkit-box;
		display: -webkit-flex;
		display: -moz-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-flex-wrap: wrap;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
	}

	.product-list .guige span {
		text-align: center;
		display: -webkit-box;
		display: -webkit-flex;
		display: -moz-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-moz-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		-moz-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		width: 62px;
		height: 62px;
		border: 1px solid #afafaf;
		border-radius: 100%;
		margin-right: 10px;
		margin-bottom: 10px;
		font-size: 12px;
		color: #666;
		line-height: 1.2em;
	}

	.product-list .guige span:nth-of-type(2n-1) {
		border-color: #119e7f;
		color: #119e7f;
	}

	.product-list .intro {
		font-size: 14px;
		line-height: 20px;
		margin-bottom: 15px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		height: 52px;
		overflow: hidden;
	}

	.brand-wrapper .btns {
		font-size: 0;
		position: absolute;
		top: -140px;
		left: calc(50% + 12px);
		margin-left: -130px;
	}

	.brand-wrapper .btns span {
		display: inline-block;
		width: 40px;
		height: 30px;
		background-repeat: no-repeat;
		background-position: 50%;
		background-size: auto 50%;
		cursor: pointer;
	}

	.brand-wrapper .brand-prev {
		margin-right: 150px;
	}

	.midswiper {
		position: relative;
		width: 100%;
		overflow: hidden;
		margin-top: -130px;
	}

	.midswiper1 {
		height: auto;
		cursor: pointer;
	}

	/* .midswiper1{height: auto;cursor: pointer;background-color: #dee8e7;} */
	.title-txt {
		position: relative;
		display: inline-block;
		padding: 40px 0;
		width: 1rem;
		font-size: 26px;
		line-height: 1;
		color: #fff;
		font-family: "syst", 'microsoft yahei';
		margin-left: 3rem;
		margin-top: 1rem;
	}

	.title-txt:before,
	.title-txt:after {
		content: '';
		position: absolute;
		left: 0;
		right: 0;
		margin: auto;
		width: 32px;
		height: 22px;
		background: url(../assets/images/png17.png) no-repeat;
	}

	.title-txt:before {
		top: 0;
		background-position: left;
	}

	.title-txt:after {
		top: 165px;
		background-position: right;
	}

	.swipermodword {
		display: flex;
		justify-content: flex-start;
		width: calc(100% - 60px);
		height: calc(100% - 30px);
		padding: 15px 30px;
		position: absolute;
		top: 0px;
		left: 0px;
		background-color: rgba(0, 0, 0, 0.3);
	}

	.swipermodword .txtword {
		font-size: 18px;
		font-family: 'syst';
		padding-left: 60px;
		line-height: 40px;
		padding-top: 40px;
		letter-spacing: 2px;
		color: #fff;
		writing-mode: vertical-lr;
		text-align: left;
		margin-top: 1rem;
	}

	.showmore {
		position: relative;
		display: inline-block;
		padding: 35px 4px;
		font-family: "微软雅黑";
		font-size: 16px;
		line-height: 1;
		-webkit-writing-mode: vertical-lr;
		writing-mode: vertical-lr;
		color: #fff;
		cursor: pointer;
		height: 72px;
		top: 25rem;
		left: 3rem;
	}

	.showmore:before {
		left: 0;
		top: 0;
		background-position: left;
	}

	.showmore:before,
	.showmore:after {
		content: '';
		position: absolute;
		width: 20px;
		height: 20px;
		background: url(../assets/images/png5.png) no-repeat;
	}

	.showmore:after {
		right: 0;
		bottom: 0;
		background-position: right;
	}

	.swipermod {
		position: relative;
		display: flex;
		align-items: center;
		width: 100%;
		height: 37rem;
	}

	.imgsty {
		width: 100%;
		height: 100%;
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
	}

	.imgsty1 {
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
	}

	.midswiper2 {
		height: 200px;
		background-color: #333333;
	}

	.midswiper2 .swipertab {
		width: 100%;
		height: 100%;
		background-position: center;
		background-repeat: no-repeat;
	}

	.midswiper2 .swiper-slide {
		width: 25%;
		height: 100;
		opacity: 0.6;
	}

	.midswiper2 .swiper-slide-active {
		opacity: 1;
	}

	.midswiper1 .swiper-slide {
		width: 25%;
		height: 100%;
		opacity: 1;
	}

	.midswiper1 .swiper-slide-active {
		opacity: 1;
		z-index: 99;
		max-width: 1400px;
	}

	.probgtry {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0px;
		left: 0px;
		z-index: 2;
	}

	.swipermodword {
		opacity: 0;
		transition: all 1.6s;
	}

	.swiper-slide-active .swipermodword {
		opacity: 1;
	}


	.ban-video video {
		width: 100%;
		display: block;
	}

	@import url("../assets/css/kaichang.css");

	::-webkit-scrollbar {
		width: 2px;
		height: 2px;
	}

	.product-list::-webkit-scrollbar-track-piece {
		background-color: #fff;
		-webkit-border-radius: 6px;
	}

	.product-list::-webkit-scrollbar-thumb:vertical {
		height: 5px;
		background-color: #666;
		-webkit-border-radius: 6px;
	}

	.product-list::-webkit-scrollbar-thumb:horizontal {
		width: 5px;
		background-color: #666;
		-webkit-border-radius: 6px;
	}

	/* .hello{background: url(../assets/images/newsbg1.jpg) 0 bottom repeat-x #efeff0;background-size: cover;} */
	.newsbg {
		padding-top: 130px;
		margin-top: -130px;
	}



	.topbannerph {
		width: 30px !important;
		height: 30px !important;
	}

	.itemph {
		display: block !important;
	}

	.itemph .intro {
		height: 40px !important;
	}

	.newsph .news-container .item {
		width: 100%;
		background-color: rgb(255, 255, 255, 0);
		border-bottom: 1px solid #e2e2e2;
	}

	.newsph .news-container a {
		padding-right: 0px;
	}

	.newsph .news-container .btn {
		display: block;
	}

	.sjmodtab {
		display: flex;
		flex-wrap: wrap;
	}
	.sjmodtabwidth{
		width: 100px!important;
	}
	.sjmodtab a{
		margin: 4px!important;
	}
</style>
